import { render } from "./Contact.vue?vue&type=template&id=482c307f&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=482c307f&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482c307f"]])

export default __exports__